import { createSelector } from 'reselect';
export const getLocation = (state) => state.router.location.pathname;
export const getQueryStrings = (state) => state.router.location.search;
export const getLocationsFromPath = createSelector([getLocation], (location) => {
    return location.split('/').filter(Boolean);
});
export const getCurrentLastPathLocation = (state) => {
    const location = state.router.location.pathname;
    return location.substr(location.lastIndexOf('/') + 1, location.length);
};
export const getLocationIsInPath = createSelector([getLocation], (fullPath) => (location) => fullPath.indexOf(location) > -1);
export const getLocationMatchesPath = createSelector([getLocation], (fullPath) => (location) => fullPath === location);
export const getUrlParams = createSelector([getQueryStrings], (queryStringParams) => {
    if (queryStringParams.length === 0) {
        return undefined;
    }
    const paramsToArray = queryStringParams.substr(1, queryStringParams.length).split('&');
    const paramsObj = {};
    paramsToArray.forEach((query) => {
        const splittedQuery = query.split('=');
        paramsObj[splittedQuery[0]] = splittedQuery[1];
    });
    return paramsObj;
});
export const getLocationFromPath = (state, location) => {
    const fullPath = state.router.location.pathname;
    let locationFound;
    location.forEach((loc) => {
        const locationIndexInPath = fullPath.indexOf(loc);
        if (locationIndexInPath > 0) {
            locationFound = fullPath.substr(locationIndexInPath, loc.length);
        }
    });
    return locationFound;
};
//# sourceMappingURL=router.selector.js.map